import Icon from '../components/Icon.vue'

Icon.register({
  braille: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M128 256C128 291.3 99.3 320 64 320S0 291.3 0 256 28.7 192 64 192 128 220.7 128 256zM64 384C46.3 384 32 398.3 32 416S46.3 448 64 448 96 433.7 96 416 81.7 384 64 384zM64 32C28.7 32 0 60.7 0 96S28.7 160 64 160 128 131.3 128 96 99.3 32 64 32zM224 224C206.3 224 192 238.3 192 256S206.3 288 224 288 256 273.7 256 256 241.7 224 224 224zM224 384C206.3 384 192 398.3 192 416S206.3 448 224 448 256 433.7 256 416 241.7 384 224 384zM224 32C188.7 32 160 60.7 160 96S188.7 160 224 160 288 131.3 288 96 259.3 32 224 32zM448 224C430.3 224 416 238.3 416 256S430.3 288 448 288 480 273.7 480 256 465.7 224 448 224zM448 384C430.3 384 416 398.3 416 416S430.3 448 448 448 480 433.7 480 416 465.7 384 448 384zM448 32C412.7 32 384 60.7 384 96S412.7 160 448 160 512 131.3 512 96 483.3 32 448 32zM608 224C590.3 224 576 238.3 576 256S590.3 288 608 288 640 273.7 640 256 625.7 224 608 224zM608 384C590.3 384 576 398.3 576 416S590.3 448 608 448 640 433.7 640 416 625.7 384 608 384zM608 64C590.3 64 576 78.3 576 96S590.3 128 608 128 640 113.7 640 96 625.7 64 608 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/braille.js
// module id = oBc+
// module chunks = 144